/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} Partner_Admin_Commission_Loading_Full_LedgerInputs */



/**
* | output |
* | --- |
* | "Loading the full ledger — {shown} of {total} entries. Quarter totals are incomplete and payout runs stay disabled until every entry has loaded." |
*
* @param {Partner_Admin_Commission_Loading_Full_LedgerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_loading_full_ledger = /** @type {((inputs: Partner_Admin_Commission_Loading_Full_LedgerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Loading_Full_LedgerInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Vollständiges Hauptbuch wird geladen — ${i?.shown} von ${i?.total} Einträgen. Quartalssummen sind unvollständig und Auszahlungsläufe bleiben deaktiviert, bis alle Einträge geladen sind.`)
	return /** @type {LocalizedString} */ (`Loading the full ledger — ${i?.shown} of ${i?.total} entries. Quarter totals are incomplete and payout runs stay disabled until every entry has loaded.`)
});